import { Injectable } from '@angular/core';

/**
 * Cmg1003ConstantsService is a placeholder for stuff carried over from
 * Clear 1 for which there is no proper place to put it. These are constants,
 * helper functions for constant values etc. Keeping them in one centralized place
 * to refactor later.
 */
@Injectable({ providedIn: 'root' })
export class Cmg1003ConstantsService {
  /**
   * Carried over from Clear1/borrowerInformation.service.ts
   * used to set max dob for borrower. Also used in GOI.
   * @returns Date
   */
  calculateFromToday(years: number, calculationMode: 'ago' | 'ahead'): Date {
    const todayDate = new Date();
    const year: number = calculationMode === 'ago' ? todayDate.getFullYear() - years : todayDate.getFullYear() + years;
    const month: number = todayDate.getMonth() + 1;
    const day: number = todayDate.getDate();
    const maxdate: Date = new Date(month.toString() + '/' + day.toString() + '/' + year.toString());
    return maxdate;
  }

  readonly date200YearsAgo = this.calculateFromToday(200, 'ago');
  readonly date18YearsAgo = this.calculateFromToday(18, 'ago');
  readonly date200YearsAhead = this.calculateFromToday(200, 'ahead');

  /**
   * https://cmgfi.atlassian.net/browse/URLA2-508
   * In Clear 1, calendar has the higher z-index than navbar. This property
   * provides a single place for all calendar instances. Navbar has sticky-top bootstrap
   * class with z-index of 1020.
   */
  readonly dateTimePickerCalendarZIndex = 1021;

  readonly modalZIndex = 1100; // 1100 will cause modal to show above the spinner (CmgBusyIndicator z-index = 1020)

  readonly mobileInputMinWidth: string = '130px';
}
